(function () {
    "use strict";

    angular.module("iMatApp")
        .component("scaleDimensions", scaleComponent());

    function scaleComponent() {
        return {
            bindings: {
                value: '<',
                minValue: '@',
                maxValue: '@',
                stepValue: '@',
                valueChanged: '&',
                precision: '@?',

                originalDimsMm: '<dimensions',
                units: '<',
                readOnly: '<',

                layout: '@?'
            },

            templateUrl: '/Scripts/iMatApp/views/scaleTemplate.html',
            controller: ScaleComponentController,
            controllerAs: "scaleViewModel"
        };
    }

    ScaleComponentController.$inject = ["utils"];

    function ScaleComponentController(utils) {
        var defaultLayout = 'full';

        var vm = this;

        vm.scale = null;
        vm.scalePercentage = scalePercentage;
        vm.width = width;
        vm.length = length;
        vm.height = height;

        vm.selectedUnits = parseInt(vm.units, 10);
        vm.toggleUnits = toggleUnits;

        vm.scale = parseFloat(vm.value);

        var minValue = parseFloat(vm.minValue);
        var maxValue = parseFloat(vm.maxValue);
        var stepValue = parseFloat(vm.stepValue);
        var precision = parseInt(vm.precision || 5, 10);

        vm.sliderOptions = getDefautSliderOptions();
        vm.sliderOptions.floor = minValue;
        vm.sliderOptions.ceil = maxValue;
        vm.sliderOptions.step = stepValue;
        vm.sliderOptions.precision = precision;

        // it will be called once all bindings are initialized
        this.$onInit = activate;
        this.$onChanges = bindingsChanged;

        // For slider we used parabola function. See example there https://jsfiddle.net/dmwr030c/35/
        var exponent = 0.2;

        // -----------------------------------------------------------------------------------

        function activate() {
            if (angular.isUndefined(vm.layout)) {
                vm.layout = defaultLayout;
            }
        }

        function bindingsChanged(changes) {
            if (changes.value) {
                setScale(changes.value.currentValue);
            }

            if (changes.units && changes.units.currentValue !== vm.selectedUnits) {
                setUnits(changes.units.currentValue);
            }

            if (changes.readOnly) {
                setDisabledStateForSlider(changes.readOnly.currentValue);
            }
        }

        function scalePercentage(strValue) {
            if (angular.isUndefined(strValue)) {
                return vm.scale;
            }

            setScale(strValue);
            return angular.undefined;
        }

        function setScale(strValue) {
            var newValue;

            var value = parseFloat(strValue);
            if (isNaN(value)) {
                value = 1;
            }

            value = utils.round(value, precision);

            if (value > maxValue) {
                newValue = maxValue;
            } else if (value < minValue) {
                newValue = minValue;
            } else {
                newValue = value;
            }

            if (newValue !== vm.value) {
                vm.value = newValue;
                vm.valueChanged({ value: newValue });
            }

            vm.scale = newValue;
        }

        function setUnits(strValue) {

            var value = parseInt(strValue, 10);
            if (isNaN(value) || value !== 0 && value !== 1) {
                value = 0;
            }

            vm.selectedUnits = value;
        }

        function setDisabledStateForSlider(newReadOnly) {
            if (angular.isDefined(newReadOnly)) {
                vm.sliderOptions.disabled = newReadOnly;
            }
        }

        function width(strValue) {
            if (angular.isUndefined(strValue)) {
                return lengthToSelectedMeasureUnit(vm.originalDimsMm.w) * vm.scale;
            }

            var value = parseFloat(strValue);
            var newScale = value / lengthToSelectedMeasureUnit(vm.originalDimsMm.w);
            setScale(newScale);

            return angular.undefined;
        }

        function length(strValue) {
            if (angular.isUndefined(strValue)) {
                return lengthToSelectedMeasureUnit(vm.originalDimsMm.l) * vm.scale;
            }

            var value = parseFloat(strValue);
            var newScale = value / lengthToSelectedMeasureUnit(vm.originalDimsMm.l);
            setScale(newScale);

            return angular.undefined;
        }

        function height(strValue) {
            if (angular.isUndefined(strValue)) {
                return lengthToSelectedMeasureUnit(vm.originalDimsMm.h) * vm.scale;
            }

            var value = parseFloat(strValue);
            var newScale = value / lengthToSelectedMeasureUnit(vm.originalDimsMm.h);
            setScale(newScale);

            return angular.undefined;
        }

        function toggleUnits() {
            if (isMmSelected()) {
                vm.selectedUnits = 1;
            } else if (isInchSelected()) {
                vm.selectedUnits = 0;
            }
        }

        function getDefautSliderOptions() {
            return {
                enforceStep: false,

                disabled: false,
                hidePointerLabels: true,
                hideLimitLabels: true,
                showSelectionBar: true,

                logScale: false,
                customValueToPosition: powValueToPosition,
                customPositionToValue: powPositionToValue,

                onEnd: slidingFinished
            };
        }

        function slidingFinished() {
            setScale(vm.scale);
            trackSliderScaleEvent();
        }

        function getUnitsRatio() {
            var inchesInMm = 1 / 25.4;
            return isMmSelected() ? 1 : inchesInMm;
        }

        function lengthToSelectedMeasureUnit(dimension) {
            return dimension * getUnitsRatio();
        }

        function isMmSelected() {
            return vm.selectedUnits === 0;
        }

        function isInchSelected() {
            return vm.selectedUnits === 1;
        }

        function powValueToPosition(val, minVal, maxVal) {
            val = f(val);
            minVal = f(minVal);
            maxVal = f(maxVal);

            var range = maxVal - minVal;
            var percent = (val - minVal) / range;

            return percent;
        }

        function powPositionToValue(percent, minVal, maxVal) {
            minVal = f(minVal);
            maxVal = f(maxVal);

            var range = maxVal - minVal;
            var value = percent * range + minVal;

            return reverseF(value);
        }

        function f(x) {
            return Math.pow(x, exponent);
        }

        function reverseF(x) {
            return Math.pow(x, 1 / exponent);
        }

        function trackSliderScaleEvent() {
            window.dataLayer.push({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Tracking] Change Model Scale',
                'eventAction': 'Single Upload Page - Slider Control',
                'eventLabel': undefined,
                'eventValue': undefined
            });

        }

    }
})();